





















































































import { helpers, required, requiredIf, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
	name: 'ScheduleInterviewDialog',

	props: {
		job_application_uuid: {
			type: String,
			required: false,
			default: null,
		},

		candidate: {
			type: Object,
			required: true,
		},
	},

	setup(props, context) {
		const { $store, $toast } = useNuxtApp();

		let error = ref<string | null>(null);
		let loading = ref<boolean>(false);

		const urlPattern = helpers.regex(
			/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
		);

		const interviewTypes = ref(['Video Call', 'In Person', 'Phone Call']);

		const job = computed(() => $store.getters['jobs/single/getSingleJob']);

		const interview = reactive<object>({
			job_uuid: job.value?.uuid,
			job_application_uuid: props.job_application_uuid,
			candidate_uuid: props.candidate.uuid,
			start_datetime: null,
			end_datetime: null,
			interview_type: null,
			link: null,
			address: null,
			interviewer_note: null,
		});

		const rules = {
			start_datetime: {
				required: helpers.withMessage('The start date field is required.', required),
			},
			end_datetime: {
				required: helpers.withMessage('The end date field is required.', required),
			},
			interview_type: {
				required: helpers.withMessage('The interview type field is required.', required),
			},
			link: {
				required: helpers.withMessage(
					'The link field is required.',
					requiredIf(() => interview.interview_type === 'Video Call'),
				),
				url: helpers.withMessage('Must be a URL starting with www.', urlPattern),
			},
			address: {
				required: helpers.withMessage(
					'The address field is required.',
					requiredIf(() => interview.interview_type === 'In Person'),
				),
			},
			interviewer_note: {
				maxLength: helpers.withMessage('The note cannot exceed 500 characters.', maxLength(500)),
			},
		};

		const v$ = useVuelidate(rules, interview);

		const schedule = async () => {
			await v$.value.$validate();

			if (v$.value.$invalid) {
				return;
			}

			loading.value = true;

			await $store
				.dispatch('interviews/schedule', interview)
				.then((res) => {
					trackInterviewSent(res);

					loading.value = false;

					v$.value.$reset();

					$toast.show({
						type: 'success',
						message: 'Interview scheduled.',
					});

					context.emit('close-modal', true);
				})
				.catch((err) => {
					error.value = err.response.data.message;

					loading.value = false;
				});
		};

		function trackInterviewSent(res) {
			context.root.$gtm.push({
				event: 'interviewSent',
				user_id: context.root.$auth.$state.user.uuid,
				company_id: context.root.$auth.$state.user.company.uuid,
				candidate_id: props.candidate.uuid,
				job_id: res.job?.uuid,
				interview_id: res.uuid,
				interview_type: res.interview_type,
			});
		}

		return {
			error,
			interview,
			interviewTypes,
			loading,
			schedule,
			v$,
		};
	},
};
